import { call, put, select } from 'redux-saga/effects';
import { iActionGetAll } from '~/domain/interfaces/redux/specialty/getAll';

import { GetAllSpecialty } from '~/domain/usecases/specialty/remote';
import { makeRemoteGetAllSpecialty } from '~/main/factories/usecases/specialty/GetAllSpecialtyFactory';

import {
  getAllSuccess,
  getAllFailed,
} from '~/data/store/reducer/specialty/actions/getAll';

export function* onGetAllRequest(action: iActionGetAll) {
  const remoteGetAllSpecialty = makeRemoteGetAllSpecialty();

  try {
    const response: GetAllSpecialty.Model = yield call(
      remoteGetAllSpecialty.getAll,
      action.payload,
    );

    yield put(getAllSuccess(response));
  } catch (e) {
    yield put(getAllFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllFailed() {}
